import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useSwot } from '../context/SwotContext';

const { FiEdit2, FiCheck, FiX } = FiIcons;

const SwotHeader = () => {
  const { title, description, setTitle, setDescription } = useSwot();
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [tempTitle, setTempTitle] = useState(title);
  const [tempDescription, setTempDescription] = useState(description);

  const handleTitleSave = () => {
    setTitle(tempTitle);
    setIsEditingTitle(false);
  };

  const handleTitleCancel = () => {
    setTempTitle(title);
    setIsEditingTitle(false);
  };

  const handleDescriptionSave = () => {
    setDescription(tempDescription);
    setIsEditingDescription(false);
  };

  const handleDescriptionCancel = () => {
    setTempDescription(description);
    setIsEditingDescription(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="text-center mb-8"
    >
      <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
        {/* Title Section */}
        <div className="mb-6">
          {isEditingTitle ? (
            <div className="flex items-center justify-center gap-3">
              <input
                type="text"
                value={tempTitle}
                onChange={(e) => setTempTitle(e.target.value)}
                className="text-4xl font-bold text-gray-800 bg-transparent border-b-2 border-blue-500 focus:outline-none text-center"
                autoFocus
                onKeyDown={(e) => e.key === 'Enter' && handleTitleSave()}
              />
              <div className="flex gap-2">
                <button
                  onClick={handleTitleSave}
                  className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                >
                  <SafeIcon icon={FiCheck} className="w-5 h-5" />
                </button>
                <button
                  onClick={handleTitleCancel}
                  className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                >
                  <SafeIcon icon={FiX} className="w-5 h-5" />
                </button>
              </div>
            </div>
          ) : (
            <div className="flex items-center justify-center gap-3 group">
              <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                {title}
              </h1>
              <button
                onClick={() => setIsEditingTitle(true)}
                className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all opacity-0 group-hover:opacity-100"
              >
                <SafeIcon icon={FiEdit2} className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>

        {/* Description Section */}
        <div>
          {isEditingDescription ? (
            <div className="flex items-center justify-center gap-3">
              <textarea
                value={tempDescription}
                onChange={(e) => setTempDescription(e.target.value)}
                className="text-lg text-gray-600 bg-transparent border-b-2 border-blue-500 focus:outline-none text-center resize-none"
                placeholder="Add a description for your SWOT analysis..."
                rows={2}
                autoFocus
              />
              <div className="flex gap-2">
                <button
                  onClick={handleDescriptionSave}
                  className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                >
                  <SafeIcon icon={FiCheck} className="w-5 h-5" />
                </button>
                <button
                  onClick={handleDescriptionCancel}
                  className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                >
                  <SafeIcon icon={FiX} className="w-5 h-5" />
                </button>
              </div>
            </div>
          ) : (
            <div className="flex items-center justify-center gap-3 group">
              <p className="text-lg text-gray-600 max-w-2xl">
                {description || "Click to add a description for your SWOT analysis"}
              </p>
              <button
                onClick={() => setIsEditingDescription(true)}
                className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all opacity-0 group-hover:opacity-100"
              >
                <SafeIcon icon={FiEdit2} className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default SwotHeader;